<template>
  <div>
    <ProgressSpinner
      v-if="loading"
      style="width:25px; height:25px; width: 100%;"
      strokeWidth="2"
      fill="#EEEEEE"
      animationDuration=".5s"
    />
    <ActivityForm
      v-else
      mode="task"
      :activityForm="true"
      :activityToEdit="activity"
      :disabledArr="[]"
      @close="backToTasks"
      @saved="backToTasks"
    />
  </div>
</template>

<script>
// /taskPage/new and /taskPage/:activityid - the task form on a page of its own,
// so "New Task" and a link to a task open the same form the Tasks list uses.
// A Meeting is an activity, not a task: it goes to its activity detail page.
import ActivityForm from "@/mbp/universalComponents/activity/ActivityForm.vue";
import { formModeFor } from "@/mbp/activityKind.js";
import ActivityService from "@/service/ActivityService";

export default {
  components: {
    ActivityForm
  },
  data: () => ({
    activityService: new ActivityService(),
    activity: {},
    loading: true
  }),
  created() {
    const activityId = this.$route.params.activityid;

    if (!activityId) {
      this.loading = false;
      return;
    }

    this.activityService
      .getActivity(activityId)
      .then(data => {
        if (formModeFor(data, "task") === "activity") {
          this.$router.replace({ path: `/activities/${activityId}/detail` });
          return;
        }
        this.activity = data;
        this.activity.updatedBy = this.$store.getters["auth/getMyProfile"].id;
        this.loading = false;
      })
      .catch(() => {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Error while getting the task",
          life: 5000
        });
        this.backToTasks();
      });
  },
  methods: {
    backToTasks() {
      this.$router.push({ name: "tasks" });
    }
  }
};
</script>
